import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { storesManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.SUPER_ADMIN];

const storesManagementManagementRouteMetadata: IRouteMetadataObj<
  typeof storesManagementRoutesObj
> = {
  list: {
    title: "storesManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/storesManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "Store3Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "storesManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/storesManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "storesManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/storesManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "storesManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/storesManagement/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  resetStorePassword: {
    title: "storesManagement.resetStorePassword.title",
    description: "empty",
    lazy: () => import("@/pages/storesManagement/resetPassword/form/page"),
    mode: "create",
    type: "inner",
    icon: "LockLine",
    breadcrumbs: [],
    permission,
  },
  subscriptionHistory: {
    title: "storesManagement.subscriptionHistory.title",
    description: "empty",
    lazy: () =>
      import("@/pages/storesManagement/subscriptionHistory/view/page"),
    mode: "view",
    type: "inner",
    icon: "FolderHistoryLine",
    breadcrumbs: [],
    permission,
  },
  subscriptionRenewal: {
    title: "storesManagement.subscriptionRenewal.title",
    description: "empty",
    lazy: () =>
      import("@/pages/storesManagement/subscriptionRenewal/form/page"),
    mode: "create",
    type: "inner",
    icon: "RefreshLine",
    breadcrumbs: [],
    permission,
  },
};

export const storesManagementRoutes = createRoute<
  typeof storesManagementRoutesObj
>(storesManagementRoutesObj, storesManagementManagementRouteMetadata);
